var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnBaisse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 33.6 31.9",
    style: {
      enableBackground: "new 0 0 33.6 31.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    stroke: "current",
    className: "st0",
    d: "M28.1,1.4v4.8h2.3c1.1,0,2.1,0.6,2.6,1.5c0.5,1,0.4,2.1-0.2,3L19.1,30.5c-0.5,0.8-1.4,1.2-2.4,1.2 c-1,0-1.8-0.5-2.4-1.2L0.7,10.7c-0.6-0.9-0.7-2-0.2-3C1,6.8,2,6.2,3.1,6.2h2.3V1.4c0-0.6,0.5-1.2,1.2-1.2h20.4 C27.6,0.2,28.1,0.7,28.1,1.4z M7.7,7.4c0,0.6-0.5,1.2-1.2,1.2H3.1c-0.3,0-0.4,0.2-0.5,0.3s-0.1,0.3,0,0.6l13.7,19.8 c0.1,0.2,0.3,0.2,0.4,0.2c0.1,0,0.3,0,0.4-0.2L30.8,9.4l0,0c0.2-0.2,0.1-0.5,0-0.6s-0.2-0.3-0.5-0.3h-3.5c-0.6,0-1.2-0.5-1.2-1.2 V2.5H7.7V7.4z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnBaisse);
export default __webpack_public_path__ + "static/media/EnBaisse.c1c5e007.svg";
export { ForwardRef as ReactComponent };